import * as t from 'io-ts';

import {CellsListsState, RCellsListsState} from './cellsLists/cellsListsState';
import {CommentComposerState, RCommentComposerState} from './commentComposer/commentComposerState';
import {
  RecentCommunicationsState,
  RRecentCommunicationsState,
} from './recentCommunications/recentCommunicationsState';

/*
 * Runtime types.
 */

export const RMetadataState = t.type({
  cellsLists: RCellsListsState,
  commentComposer: RCommentComposerState,
  recentCommunications: RRecentCommunicationsState,
});

/*
 * Types.
 */

// TODO: Figure out why t.TypeOf<RMetadataState> does not agree with this.
export interface MetadataState {
  readonly cellsLists: CellsListsState;
  readonly commentComposer: CommentComposerState;
  readonly recentCommunications: RecentCommunicationsState;
}
